<template>
  <b-container class="pt-5 min-vh-100" v-if="user">
    <b-row>
      <b-col>
        <div class="page-title pt-5 mb-4">Welcome {{ user.full_name }}!</div>
        <b-card
          overlay
          img-src="https://picsum.photos/900/250/?image=3"
          img-alt="Card Image"
          text-variant="white"
          title="Image Overlay"
        >
          <b-card-text>
            Some quick example text to build on the card and make up the bulk of
            the card's content.
          </b-card-text>
        </b-card>
      </b-col>
    </b-row>

    <b-row class="mt-4" v-for="i in 2" :key="i">
      <b-col cols="4" v-for="j in 3" :key="j">
        <b-list-group>
          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            Cras justo odio
            <b-badge variant="primary" pill>14</b-badge>
          </b-list-group-item>

          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            Dapibus ac facilisis in
            <b-badge variant="primary" pill>2</b-badge>
          </b-list-group-item>

          <b-list-group-item
            class="d-flex justify-content-between align-items-center"
          >
            Morbi leo risus
            <b-badge variant="primary" pill>1</b-badge>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  methods: {
    ...mapActions({
      getAuthenticatedUser: 'auth/getAuthenticatedUser'
    })
  },

  async created() {
    await this.getAuthenticatedUser()

    /**
     * To be discussed since onboarding has
     * skip button that redirects to profile page
     **/
    // if (
    //   this.user &&
    //   !this.user.first_name &&
    //   !this.user.last_name &&
    //   !this.user.phone_number
    // ) {
    //   this.$router.replace({ name: 'auth.onboarding-page' })
    // }
  }
}
</script>

<style scoped lang="scss">
.card-header {
  background-color: #ffffff;
}
</style>
